
import Vue from 'vue';
import Signup from "./ns-signup-vue/ns-signup-vue.vue";
import AcceptTc from "./ns-accept-tc/ns-accept-tc.vue";

const Components = {
  NsLoyaltySignup: Signup,
  NsLoyaltyAcceptTc: AcceptTc
};

Object.keys(Components).forEach((name) => {
  Vue.component(name, Components[name]);
});

export const NsLoyaltySignup = Signup
export const NsLoyaltyAcceptTc = AcceptTc